import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import setupAxiosInterceptors from './functions/AxiosInterceptor';

setupAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

